const listeners = new Set();

export function onCollectionEvent(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

export function emitCollectionEvent(event) {
  // event: { type: 'added'|'removed'|'updated', clip: {...}, clipId }
  for (const fn of Array.from(listeners)) {
    try {
      fn(event);
    } catch (e) {
      // ignore listener errors
      // eslint-disable-next-line no-console
      console.error('collectionBus listener error', e);
    }
  }
}

export default { onCollectionEvent, emitCollectionEvent };
